import { useEffect } from 'react';
import { useAuth } from '@city-sage/aurum-avis-labs-components';
import { useIsAuthenticated } from '@azure/msal-react';
import LogRocket from 'logrocket';

/**
 * Component that identifies users with LogRocket when they are authenticated
 * This should be used within components that have access to AuthProvider
 */
export const LogRocketAuthIdentifier = () => {
  const { userEmail, userName } = useAuth();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    console.log('[LogRocket] Auth identifier - state changed:', {
      isAuthenticated,
      hasUserEmail: !!userEmail,
      hasUserName: !!userName,
      userEmail: userEmail ? `${userEmail.substring(0, 3)}***` : null, // Partially masked for privacy
      userName: userName ? `${userName.substring(0, 3)}***` : null, // Partially masked for privacy
      timestamp: new Date().toISOString()
    });

    if (isAuthenticated && userEmail) {
      // Check if LogRocket is available (not in dev mode)
      if (import.meta.env.DEV) {
        console.log('[LogRocket] Skipping user identification in development mode');
        return;
      }

      try {
        // Identify user with LogRocket using email as the unique identifier
        LogRocket.identify(userEmail, {
          name: userName || 'anonymous',
          email: userEmail,
        });
        
        console.log('[LogRocket] Successfully identified user with auth context:', {
          email: `${userEmail.substring(0, 3)}***`, // Partially masked for privacy
          name: userName ? `${userName.substring(0, 3)}***` : null, // Partially masked for privacy
          timestamp: new Date().toISOString()
        });
      } catch (error) {
        console.error('[LogRocket] Failed to identify user:', error);
      }
    } else if (isAuthenticated && !userEmail) {
      console.warn('[LogRocket] User is authenticated but no email available for identification');
    } else if (!isAuthenticated) {
      console.log('[LogRocket] User not authenticated in auth context');
    }
  }, [isAuthenticated, userEmail, userName]);

  return null;
}; 